"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.WritebackRunOverallStatusType = exports.WebDashboardSharingLevel = exports.UserRoleType = exports.TableauWorksheetZoneType = exports.TableauWorksheetParameterType = exports.TableauWorksheetFilterType = exports.TableauDownloadType = exports.TableauConnectedAppTrustType = exports.SubscriptionPlanType = exports.SpreadsheetColumnBehavior = exports.SortType = exports.SnowflakeKeypairOrigin = exports.SalesforceReportType = exports.SalesforceReportRenderType = exports.SalesforceFetchMode = exports.SalesforceCustomFetchType = exports.SSOAuthorizationURLResponseMode = exports.RestrictedFieldOptions = exports.OauthAttemptTestStatus = exports.NumberFilterType = exports.MergedCellValueOption = exports.IdentityProvider = exports.FlatColumnType = exports.FilterOperatorType = exports.FilterOperandType = exports.FilterClauseOperand = exports.ExcelSourceType = exports.DateFilterType = exports.DataSourceType = exports.DataSourceConnectionStatusType = exports.DataImportScheduleRepeatType = exports.DataImportRunStatusType = exports.CSVSourceType = exports.AllowOrDisallowOption = exports.AlertType = exports.AlertScheduleRepeatType = void 0;
var axios_1 = __importDefault(require("axios"));
var common_1 = require("./common");
var base_1 = require("./base");
exports.AlertScheduleRepeatType = {
    Hourly: 'hourly',
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly'
};
exports.AlertType = {
    MonitorChange: 'monitor_change',
    MonitorCondition: 'monitor_condition',
    NewRowsAppended: 'new_rows_appended',
    NewRowsWithId: 'new_rows_with_id',
    Snapshot: 'snapshot'
};
exports.AllowOrDisallowOption = {
    Allow: 'allow',
    Disallow: 'disallow'
};
exports.CSVSourceType = {
    GoogleDrive: 'google_drive',
    OneDrive: 'one_drive',
    Box: 'box',
    Upload: 'upload',
    Url: 'url',
    Egnyte: 'egnyte'
};
exports.DataImportRunStatusType = {
    Failed: 'Failed',
    Ok: 'OK'
};
exports.DataImportScheduleRepeatType = {
    Hourly: 'hourly',
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly'
};
exports.DataSourceConnectionStatusType = {
    Failed: 'failed',
    Ok: 'ok'
};
exports.DataSourceType = {
    Csv: 'csv',
    GoogleSheets: 'google_sheets',
    Salesforce: 'salesforce',
    GptCopilot: 'gpt_copilot',
    Looker: 'looker',
    GoogleAnalytics: 'google_analytics',
    Hubspot: 'hubspot',
    Tableau: 'tableau',
    Jira: 'jira',
    Stripe: 'stripe',
    Zendesk: 'zendesk',
    Quickbooks: 'quickbooks',
    Shopify: 'shopify',
    GoogleDrive: 'google_drive',
    Excel: 'excel',
    Airtable: 'airtable',
    Mailchimp: 'mailchimp',
    Pipedrive: 'pipedrive',
    OneDrive: 'one_drive',
    SharepointLists: 'sharepoint_lists',
    Egnyte: 'egnyte',
    Box: 'box',
    Outreach: 'outreach',
    GoogleAnalytics4: 'google_analytics_4',
    GoogleSearchConsole: 'google_search_console',
    GoogleAds: 'google_ads',
    CloudTable: 'cloud_table',
    FacebookAds: 'facebook_ads',
    Notion: 'notion',
    Chargebee: 'chargebee',
    LinkedinAds: 'linkedin_ads',
    FacebookInsights: 'facebook_insights',
    YoutubeAnalytics: 'youtube_analytics',
    LinkedinPages: 'linkedin_pages',
    Linkedin: 'linkedin',
    CustomApi: 'custom_api',
    InstagramInsights: 'instagram_insights',
    MicrosoftAds: 'microsoft_ads',
    Netsuite: 'netsuite',
    NetsuiteCrx: 'netsuite_crx',
    Xero: 'xero',
    Klaviyo: 'klaviyo',
    Asana: 'asana',
    Razorpay: 'razorpay',
    Clickup: 'clickup',
    Typeform: 'typeform',
    Harvest: 'harvest',
    Freshdesk: 'freshdesk',
    Paymo: 'paymo',
    GoogleCalendar: 'google_calendar',
    AmazonSellerCentral: 'amazon_seller_central',
    Trello: 'trello',
    Gong: 'gong',
    Calendly: 'calendly',
    Smartsheet: 'smartsheet',
    RedditAds: 'reddit_ads',
    Surveymonkey: 'surveymonkey',
    QuoraAds: 'quora_ads',
    Podio: 'podio',
    Greenhouse: 'greenhouse',
    Gusto: 'gusto',
    Intercom: 'intercom',
    Etsy: 'etsy',
    PinterestAds: 'pinterest_ads',
    ActiveCampaign: 'active_campaign',
    Jotform: 'jotform',
    Basecamp: 'basecamp',
    Zohobooks: 'zohobooks',
    Coda: 'coda',
    Square: 'square',
    Zoom: 'zoom',
    Webflow: 'webflow',
    ZohoCrm: 'zoho_crm',
    Bigin: 'bigin',
    Lever: 'lever',
    Salesloft: 'salesloft',
    Wordpress: 'wordpress',
    WooCommerce: 'woo_commerce',
    Bigcommerce: 'bigcommerce',
    Smartlead: 'smartlead',
    Affinity: 'affinity',
    Shiprocket: 'shiprocket',
    AwsBilling: 'aws_billing',
    Gmail: 'gmail',
    Sage: 'sage',
    GoogleClassroom: 'google_classroom',
    Campfire: 'campfire',
    Rillet: 'rillet',
    NetflixQuiver: 'netflix_quiver',
    AnyApiAgent: 'any_api_agent',
    BrowserAgent: 'browser_agent',
    Mysql: 'mysql',
    Redshift: 'redshift',
    Postgres: 'postgres',
    Snowflake: 'snowflake',
    Mssql: 'mssql',
    Bigquery: 'bigquery',
    Databricks: 'databricks',
    ArrowFlightSql: 'arrow_flight_sql',
    Motherduck: 'motherduck',
    Clickhouse: 'clickhouse',
    AuroraPostgres: 'aurora_postgres',
    AuroraMysql: 'aurora_mysql',
    CloudSqlPostgres: 'cloud_sql_postgres',
    CloudSqlMysql: 'cloud_sql_mysql',
    Supabase: 'supabase',
    Neon: 'neon',
    Timescaledb: 'timescaledb',
    AzurePostgres: 'azure_postgres',
    AzureMysql: 'azure_mysql',
    AzureSql: 'azure_sql',
    Rippling: 'rippling',
    Apollo: 'apollo',
    Amplitude: 'amplitude',
    Sendgrid: 'sendgrid',
    Chargify: 'chargify',
    Marketo: 'marketo',
    Mongodb: 'mongodb',
    WebScraper: 'web_scraper',
    ChargebeeAi: 'chargebee_ai',
    StripeAi: 'stripe_ai',
    OutreachAi: 'outreach_ai',
    ClickupAi: 'clickup_ai',
    JiraAi: 'jira_ai',
    SquareAi: 'square_ai',
    ExpensifyAi: 'expensify_ai',
    TwilioAi: 'twilio_ai',
    SendgridAi: 'sendgrid_ai',
    KitAi: 'kit_ai',
    InsightlyAi: 'insightly_ai',
    FreshsalesAi: 'freshsales_ai',
    CloseAi: 'close_ai',
    XeroAi: 'xero_ai',
    ModeAi: 'mode_ai',
    MondayAi: 'monday_ai',
    MixpanelAi: 'mixpanel_ai',
    ClockifyAi: 'clockify_ai',
    KobotoolboxAi: 'kobotoolbox_ai',
    TogglTrackAi: 'toggl_track_ai',
    SmartsuiteAi: 'smartsuite_ai',
    OdooAi: 'odoo_ai',
    LinearAi: 'linear_ai',
    KlaviyoAi: 'klaviyo_ai',
    RazorpayAi: 'razorpay_ai',
    PaymoAi: 'paymo_ai',
    ActiveCampaignAi: 'active_campaign_ai',
    WordpressAi: 'wordpress_ai',
    WooCommerceAi: 'woo_commerce_ai',
    SmartleadAi: 'smartlead_ai',
    ShiprocketAi: 'shiprocket_ai',
    RipplingAi: 'rippling_ai',
    HarvestAi: 'harvest_ai',
    CalendlyAi: 'calendly_ai',
    ZohobooksAi: 'zohobooks_ai',
    ZohoCrmAi: 'zoho_crm_ai',
    BiginAi: 'bigin_ai',
    ApolloAi: 'apollo_ai',
    FreshdeskAi: 'freshdesk_ai',
    GreenhouseAi: 'greenhouse_ai',
    TrelloAi: 'trello_ai',
    JotformAi: 'jotform_ai',
    CodaAi: 'coda_ai',
    TypeformAi: 'typeform_ai',
    PodioAi: 'podio_ai',
    SmartsheetAi: 'smartsheet_ai',
    BasecampAi: 'basecamp_ai',
    MetabaseAi: 'metabase_ai',
    TeamworkAi: 'teamwork_ai',
    CatsAtsAi: 'cats_ats_ai',
    NutshellAi: 'nutshell_ai',
    PipelinerAi: 'pipeliner_ai',
    SalesflareAi: 'salesflare_ai',
    VtigerCrmAi: 'vtiger_crm_ai',
    FreshserviceAi: 'freshservice_ai',
    HiveAi: 'hive_ai',
    AircallAi: 'aircall_ai',
    NimbleCrmAi: 'nimble_crm_ai',
    DripAi: 'drip_ai',
    PaddleAi: 'paddle_ai',
    AgileCrmAi: 'agile_crm_ai',
    CheckoutAi: 'checkout_ai',
    CapsuleAi: 'capsule_ai',
    BitbucketAi: 'bitbucket_ai',
    GitlabAi: 'gitlab_ai',
    HelpscoutAi: 'helpscout_ai',
    FrontAi: 'front_ai',
    WrikeAi: 'wrike_ai',
    BamboohrAi: 'bamboohr_ai',
    DeelAi: 'deel_ai',
    ConfluenceAi: 'confluence_ai',
    TeamleaderAi: 'teamleader_ai',
    MiroAi: 'miro_ai',
    OmnisendAi: 'omnisend_ai',
    AttioAi: 'attio_ai',
    CreatioAi: 'creatio_ai',
    FreeagentAi: 'freeagent_ai',
    MoneybirdAi: 'moneybird_ai',
    AcceloAi: 'accelo_ai',
    ApplicantstackAi: 'applicantstack_ai',
    AlowareAi: 'aloware_ai',
    StackbyAi: 'stackby_ai',
    FloatAi: 'float_ai',
    ClickhouseAi: 'clickhouse_ai',
    AppsflyerAi: 'appsflyer_ai',
    MariadbAi: 'mariadb_ai',
    LaunchdarklyAi: 'launchdarkly_ai',
    PosthogAi: 'posthog_ai',
    DovetailAi: 'dovetail_ai',
    ShipstationAi: 'shipstation_ai',
    MindbodyAi: 'mindbody_ai',
    GrowwAi: 'groww_ai',
    AmazonSellerCentralAi: 'amazon_seller_central_ai',
    AirwallexAi: 'airwallex_ai',
    StatsigAi: 'statsig_ai',
    ModernTreasuryAi: 'modern_treasury_ai',
    RudderstackAi: 'rudderstack_ai',
    BrightDataAi: 'bright_data_ai',
    VwoAi: 'vwo_ai',
    PartnerizeAi: 'partnerize_ai',
    RilletAi: 'rillet_ai',
    TrolleyAi: 'trolley_ai',
    ScalefusionAi: 'scalefusion_ai',
    BaremetricsAi: 'baremetrics_ai',
    TodoistAi: 'todoist_ai',
    WorkableAi: 'workable_ai',
    PlausibleAi: 'plausible_ai',
    ApifyAi: 'apify_ai',
    DatascopeAi: 'datascope_ai',
    GorgiasAi: 'gorgias_ai',
    EverhourAi: 'everhour_ai',
    ExchangeratesAi: 'exchangerates_ai',
    FastbillAi: 'fastbill_ai',
    GlassfrogAi: 'glassfrog_ai',
    ResourceFlowHubplannerAi: 'resource_flow_hubplanner_ai',
    KatanaAi: 'katana_ai',
    MyhoursAi: 'myhours_ai',
    FisRailzAi: 'fis_railz_ai',
    TellentHrisAi: 'tellent_hris_ai',
    SimfinAi: 'simfin_ai',
    SmartwaiverAi: 'smartwaiver_ai',
    LokaliseAi: 'lokalise_ai',
    MailerliteAi: 'mailerlite_ai',
    MailersendAi: 'mailersend_ai',
    OnesignalAi: 'onesignal_ai',
    PostmarkAi: 'postmark_ai',
    ShortIoAi: 'short_io_ai',
    YotpoAi: 'yotpo_ai',
    ChartmogulAi: 'chartmogul_ai',
    ConfigcatAi: 'configcat_ai',
    PingdomAi: 'pingdom_ai',
    RetentlyAi: 'retently_ai',
    CoinmarketcapAi: 'coinmarketcap_ai',
    SoftrIoAi: 'softr_io_ai',
    EmailoctopusAi: 'emailoctopus_ai',
    GridlyAi: 'gridly_ai',
    MixmaxAi: 'mixmax_ai',
    ReplyIoAi: 'reply_io_ai',
    LessAnnoyingCrmAi: 'less_annoying_crm_ai',
    SnovIoAi: 'snov_io_ai',
    OnepagecrmAi: 'onepagecrm_ai',
    LemlistAi: 'lemlist_ai'
};
exports.DateFilterType = {
    LastWeekSunSat: 'last_week_sun_sat',
    LastWeekMonSun: 'last_week_mon_sun',
    ThisMonthToDate: 'this_month_to_date',
    ThisMonthToYesterday: 'this_month_to_yesterday',
    LastMonth: 'last_month',
    YearToDate: 'year_to_date',
    LastYear: 'last_year',
    LastYearAndYearToDate: 'last_year_and_year_to_date',
    LastXWeeksSunSat: 'last_x_weeks_sun_sat',
    LastXWeeksMonSun: 'last_x_weeks_mon_sun',
    CustomDateRange: 'custom_date_range',
    Today: 'today',
    Tomorrow: 'tomorrow',
    Yesterday: 'yesterday',
    CurrentWeek: 'current_week',
    CurrentMonth: 'current_month',
    CurrentYear: 'current_year',
    LastMonthEnd: 'last_month_end',
    LastXDays: 'last_x_days',
    LastXWeeks: 'last_x_weeks',
    LastXMonths: 'last_x_months',
    LastXYears: 'last_x_years',
    NextXDays: 'next_x_days',
    NextXWeeks: 'next_x_weeks',
    NextXMonths: 'next_x_months',
    NextXYears: 'next_x_years',
    ExactDate: 'exact_date',
    ExactDates: 'exact_dates',
    MatchesAdvanced: 'matches_advanced',
    Now: 'now',
    LastXSeconds: 'last_x_seconds',
    LastXMinutes: 'last_x_minutes',
    LastXHours: 'last_x_hours',
    LastXQuarters: 'last_x_quarters',
    NextXSeconds: 'next_x_seconds',
    NextXMinutes: 'next_x_minutes',
    NextXHours: 'next_x_hours',
    NextXQuarters: 'next_x_quarters',
    LastXCompleteSeconds: 'last_x_complete_seconds',
    LastXCompleteMinutes: 'last_x_complete_minutes',
    LastXCompleteHours: 'last_x_complete_hours',
    LastXCompleteDays: 'last_x_complete_days',
    LastXCompleteWeeks: 'last_x_complete_weeks',
    LastXCompleteMonths: 'last_x_complete_months',
    LastXCompleteQuarters: 'last_x_complete_quarters',
    LastXCompleteYears: 'last_x_complete_years',
    NextXCompleteSeconds: 'next_x_complete_seconds',
    NextXCompleteMinutes: 'next_x_complete_minutes',
    NextXCompleteHours: 'next_x_complete_hours',
    NextXCompleteDays: 'next_x_complete_days',
    NextXCompleteWeeks: 'next_x_complete_weeks',
    NextXCompleteMonths: 'next_x_complete_months',
    NextXCompleteQuarters: 'next_x_complete_quarters',
    NextXCompleteYears: 'next_x_complete_years'
};
exports.ExcelSourceType = {
    GoogleDrive: 'google_drive',
    OneDrive: 'one_drive',
    Box: 'box',
    Upload: 'upload',
    Url: 'url',
    Egnyte: 'egnyte'
};
exports.FilterClauseOperand = {
    And: 'and',
    Or: 'or'
};
exports.FilterOperandType = {
    Number: 'number',
    Text: 'text',
    Date: 'date',
    Boolean: 'boolean',
    Location: 'location',
    CellRefA1: 'cell_ref_a1'
};
exports.FilterOperatorType = {
    NumberEq: 'number_eq',
    NumberNe: 'number_ne',
    NumberLt: 'number_lt',
    NumberLte: 'number_lte',
    NumberGt: 'number_gt',
    NumberGte: 'number_gte',
    NumberIsEmpty: 'number_is_empty',
    NumberIsNotEmpty: 'number_is_not_empty',
    NumberIsOneOf: 'number_is_one_of',
    NumberIsNotOneOf: 'number_is_not_one_of',
    NumberIsBetween: 'number_is_between',
    NumberIsNotBetween: 'number_is_not_between',
    NumberMatchesAdvanced: 'number_matches_advanced',
    NumberIsNull: 'number_is_null',
    NumberIsNotNull: 'number_is_not_null',
    TextIsNotEmpty: 'text_is_not_empty',
    TextIsEmpty: 'text_is_empty',
    TextContains: 'text_contains',
    TextIsExactly: 'text_is_exactly',
    TextIsNotExactly: 'text_is_not_exactly',
    TextDoesNotContain: 'text_does_not_contain',
    TextIsOneOf: 'text_is_one_of',
    TextIsNotOneOf: 'text_is_not_one_of',
    TextStartsWith: 'text_starts_with',
    TextDoesNotStartsWith: 'text_does_not_starts_with',
    TextEndsWith: 'text_ends_with',
    TextDoesNotEndsWith: 'text_does_not_ends_with',
    TextIsBlank: 'text_is_blank',
    TextIsNotBlank: 'text_is_not_blank',
    TextMatchesAdvanced: 'text_matches_advanced',
    TextIsNull: 'text_is_null',
    TextIsNotNull: 'text_is_not_null',
    TextIsAnyvalue: 'text_is_anyvalue',
    DateIs: 'date_is',
    DateIsWithin: 'date_is_within',
    DateIsBefore: 'date_is_before',
    DateIsAfter: 'date_is_after',
    DateIsOnOrBefore: 'date_is_on_or_before',
    DateIsOnOrAfter: 'date_is_on_or_after',
    DateIsEmpty: 'date_is_empty',
    DateIsNotEmpty: 'date_is_not_empty',
    DateIsAnytime: 'date_is_anytime',
    DateMatchesAdvanced: 'date_matches_advanced',
    DateIsNull: 'date_is_null',
    DateIsNotNull: 'date_is_not_null',
    DateIsInTheLast: 'date_is_in_the_last',
    DateIsOnTheDay: 'date_is_on_the_day',
    DateIsInTheYear: 'date_is_in_the_year',
    DateIsInTheMonth: 'date_is_in_the_month',
    DateIsThis: 'date_is_this',
    DateIsNext: 'date_is_next',
    DateIsPrevious: 'date_is_previous',
    BooleanIsTrue: 'boolean_is_true',
    BooleanIsFalse: 'boolean_is_false',
    BooleanIsEmpty: 'boolean_is_empty',
    BooleanIsNotEmpty: 'boolean_is_not_empty',
    BooleanIsAnyValue: 'boolean_is_any_value',
    PicklistIsOneOf: 'picklist_is_one_of',
    PicklistIsNotOneOf: 'picklist_is_not_one_of',
    PicklistIsEmpty: 'picklist_is_empty',
    PicklistIsNotEmpty: 'picklist_is_not_empty',
    PicklistIsEqualTo: 'picklist_is_equal_to',
    PicklistIsAnyValue: 'picklist_is_any_value',
    MultipicklistHasAnyOneOf: 'multipicklist_has_any_one_of',
    MultipicklistDoesNotHaveAnyOf: 'multipicklist_does_not_have_any_of',
    MultipicklistIsEmpty: 'multipicklist_is_empty',
    MultipicklistIsNotEmpty: 'multipicklist_is_not_empty',
    LocationIsAnywhere: 'location_is_anywhere',
    LocationIsNull: 'location_is_null',
    LocationIsNotNull: 'location_is_not_null',
    LocationIsExactly: 'location_is_exactly',
    LocationIsInTheBox: 'location_is_in_the_box',
    LocationIsInTheCircle: 'location_is_in_the_circle',
    LocationMatchesAdvanced: 'location_matches_advanced'
};
exports.FlatColumnType = {
    JsonDump: 'json_dump',
    SplitToRows: 'split_to_rows',
    CommaSeparated: 'comma_separated'
};
exports.IdentityProvider = {
    Okta: 'okta',
    Duo: 'duo',
    Entra: 'entra'
};
exports.MergedCellValueOption = {
    CopyAcrossRows: 'copy_across_rows',
    CopyAcrossColumns: 'copy_across_columns',
    CopyAcrossRowsAndColumns: 'copy_across_rows_and_columns',
    KeepOriginalSparsity: 'keep_original_sparsity'
};
exports.NumberFilterType = {
    Inclusive: '[inclusive]',
    Exclusive: '(exclusive)',
    RightExclusive: '[right-exclusive)',
    LeftExclusive: '(left-exclusive]'
};
exports.OauthAttemptTestStatus = {
    InProgress: 'in_progress',
    Success: 'success',
    Failure: 'failure'
};
exports.RestrictedFieldOptions = {
    IncludeAllFields: 'include_all_fields',
    RedactRestrictedFields: 'redact_restricted_fields'
};
exports.SSOAuthorizationURLResponseMode = {
    FormPost: 'form_post',
    Query: 'query'
};
exports.SalesforceCustomFetchType = {
    Funnel: 'opportunity_funnel',
    History: 'opportunity_history',
    StageTransition: 'opportunity_stage_transition'
};
exports.SalesforceFetchMode = {
    Reports: 'reports',
    Objects: 'objects',
    SoqlQuery: 'soql_query',
    Custom: 'custom'
};
exports.SalesforceReportRenderType = {
    DetailRows: 'detail_rows',
    RetainFormat: 'retain_format'
};
exports.SalesforceReportType = {
    DetailReport: 'detail_report',
    AggregateReport: 'aggregate_report',
    JoinedReport: 'joined_report'
};
exports.SnowflakeKeypairOrigin = {
    CoeffGenerated: 'coeff_generated',
    UserUploaded: 'user_uploaded'
};
exports.SortType = {
    Asc: 'asc',
    Desc: 'desc'
};
exports.SpreadsheetColumnBehavior = {
    DontTouch: 'dont_touch',
    AutoFillDown: 'auto_fill_down'
};
exports.SubscriptionPlanType = {
    NewUser: 'new_user',
    FreeTrial: 'free_trial',
    LifetimeFree: 'lifetime_free',
    Starter: 'starter',
    Plus: 'plus',
    Pro: 'pro',
    Custom: 'custom',
    Enterprise: 'enterprise'
};
exports.TableauConnectedAppTrustType = {
    OauthTrust: 'oauth_trust',
    DirectTrust: 'direct_trust'
};
exports.TableauDownloadType = {
    Data: 'tableau_data',
    Crosstab: 'tableau_crosstab'
};
exports.TableauWorksheetFilterType = {
    Multipicklist: 'multipicklist'
};
exports.TableauWorksheetParameterType = {
    Picklist: 'picklist'
};
exports.TableauWorksheetZoneType = {
    Filter: 'filter',
    Parameter: 'parameter'
};
exports.UserRoleType = {
    Admin: 'admin',
    Member: 'member'
};
exports.WebDashboardSharingLevel = {
    Private: 'private',
    Domain: 'domain',
    Public: 'public'
};
exports.WritebackRunOverallStatusType = {
    Ok: 'ok',
    SomeRecordsFailed: 'some_records_failed',
    AllRecordsFailed: 'all_records_failed',
    DataSourceNeedsReauth: 'data_source_needs_reauth',
    UnknownError: 'unknown_error',
    MappingError: 'mapping_error',
    FreeTrialExpired: 'free_trial_expired',
    SalesforceExceededQuota: 'salesforce_exceeded_quota',
    SalesforceBulkApiNotEnabled: 'salesforce_bulk_api_not_enabled',
    SalesforceGenericError: 'salesforce_generic_error',
    HubspotGenericError: 'hubspot_generic_error',
    HubspotInvalidAssociation: 'hubspot_invalid_association',
    HubspotListNotFound: 'hubspot_list_not_found',
    SpreadsheetFormatError: 'spreadsheet_format_error',
    UnsupportedOperation: 'unsupported_operation',
    DuplicateMappedColumns: 'duplicate_mapped_columns',
    WritebackDisabled: 'writeback_disabled',
    WritebackDisabledForConnector: 'writeback_disabled_for_connector',
    DataSourceDisabledByAdmin: 'data_source_disabled_by_admin',
    SharedConnectionNotSupported: 'shared_connection_not_supported',
    NoSuchTable: 'no_such_table',
    NoSuchDatabase: 'no_such_database',
    TableHasNoId: 'table_has_no_id',
    IdNotMapped: 'id_not_mapped',
    ExternalIdNotMapped: 'external_id_not_mapped',
    FieldPermissionError: 'field_permission_error',
    TargetApiFailed: 'target_api_failed',
    ImportsInProgress: 'imports_in_progress',
    WritebackAlreadyInProgress: 'writeback_already_in_progress',
    WritebackTimedoutInQueue: 'writeback_timedout_in_queue',
    WritebackTimedoutInProgress: 'writeback_timedout_in_progress',
    WritebackTerminated: 'writeback_terminated',
    SpreadsheetNotFound: 'spreadsheet_not_found',
    SpreadsheetTabNotFound: 'spreadsheet_tab_not_found',
    ConnectionError: 'connection_error'
};
var DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        configureSSO: function (configure_sso_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin_ext/sso_config";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(configure_sso_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createOauthAttemptTest: function (create_oauth_attempt_test_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin_ext/sso_config/start_test";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_oauth_attempt_test_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteDataSource: function (data_source_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteDataSource', 'data_source_id', data_source_id);
                    localVarPath = "/api_admin_ext/data_source/{data_source_id}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteSSOConfig: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin_ext/sso_config";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAlerts: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, user_id, status, destination, alert_type, search, filters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getAlerts', 'domain', domain);
                    (0, common_1.assertParamExists)('getAlerts', 'tz_name', tz_name);
                    localVarPath = "/api_admin_ext/alerts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    if (format !== undefined) {
                        localVarQueryParameter['format'] = format;
                    }
                    if (tz_name !== undefined) {
                        localVarQueryParameter['tz_name'] = tz_name;
                    }
                    if (page_size !== undefined) {
                        localVarQueryParameter['page_size'] = page_size;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (sort_by !== undefined) {
                        localVarQueryParameter['sort_by'] = sort_by;
                    }
                    if (sort_order !== undefined) {
                        localVarQueryParameter['sort_order'] = sort_order;
                    }
                    if (user_id !== undefined) {
                        localVarQueryParameter['user_id'] = user_id;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (destination !== undefined) {
                        localVarQueryParameter['destination'] = destination;
                    }
                    if (alert_type !== undefined) {
                        localVarQueryParameter['alert_type'] = alert_type;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImportRun: function (data_import_run_id, tz_name, format, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataImportRun', 'data_import_run_id', data_import_run_id);
                    localVarPath = "/api_admin_ext/data_import_run/{data_import_run_id}"
                        .replace("{".concat("data_import_run_id", "}"), encodeURIComponent(String(data_import_run_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (tz_name !== undefined) {
                        localVarQueryParameter['tz_name'] = tz_name;
                    }
                    if (format !== undefined) {
                        localVarQueryParameter['format'] = format;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImportRuns: function (domain, data_import_id, format, limit, tz_name, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, filters, last_n_days, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataImportRuns', 'domain', domain);
                    localVarPath = "/api_admin_ext/data_import_runs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    if (data_import_id !== undefined) {
                        localVarQueryParameter['data_import_id'] = data_import_id;
                    }
                    if (format !== undefined) {
                        localVarQueryParameter['format'] = format;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (tz_name !== undefined) {
                        localVarQueryParameter['tz_name'] = tz_name;
                    }
                    if (page_size !== undefined) {
                        localVarQueryParameter['page_size'] = page_size;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (sort_by !== undefined) {
                        localVarQueryParameter['sort_by'] = sort_by;
                    }
                    if (sort_order !== undefined) {
                        localVarQueryParameter['sort_order'] = sort_order;
                    }
                    if (data_source_type !== undefined) {
                        localVarQueryParameter['data_source_type'] = data_source_type;
                    }
                    if (user_id !== undefined) {
                        localVarQueryParameter['user_id'] = user_id;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (trigger !== undefined) {
                        localVarQueryParameter['trigger'] = trigger;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (last_n_days !== undefined) {
                        localVarQueryParameter['last_n_days'] = last_n_days;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImports: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, schedule, search, filters, data_source_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataImports', 'domain', domain);
                    (0, common_1.assertParamExists)('getDataImports', 'tz_name', tz_name);
                    localVarPath = "/api_admin_ext/data_imports";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    if (format !== undefined) {
                        localVarQueryParameter['format'] = format;
                    }
                    if (tz_name !== undefined) {
                        localVarQueryParameter['tz_name'] = tz_name;
                    }
                    if (page_size !== undefined) {
                        localVarQueryParameter['page_size'] = page_size;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (sort_by !== undefined) {
                        localVarQueryParameter['sort_by'] = sort_by;
                    }
                    if (sort_order !== undefined) {
                        localVarQueryParameter['sort_order'] = sort_order;
                    }
                    if (data_source_type !== undefined) {
                        localVarQueryParameter['data_source_type'] = data_source_type;
                    }
                    if (user_id !== undefined) {
                        localVarQueryParameter['user_id'] = user_id;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (schedule !== undefined) {
                        localVarQueryParameter['schedule'] = schedule;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (data_source_id !== undefined) {
                        localVarQueryParameter['data_source_id'] = data_source_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataSource: function (data_source_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataSource', 'data_source_id', data_source_id);
                    localVarPath = "/api_admin_ext/data_source/{data_source_id}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataSources: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, is_shared, search, filters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataSources', 'domain', domain);
                    (0, common_1.assertParamExists)('getDataSources', 'tz_name', tz_name);
                    localVarPath = "/api_admin_ext/data_sources";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    if (format !== undefined) {
                        localVarQueryParameter['format'] = format;
                    }
                    if (tz_name !== undefined) {
                        localVarQueryParameter['tz_name'] = tz_name;
                    }
                    if (page_size !== undefined) {
                        localVarQueryParameter['page_size'] = page_size;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (sort_by !== undefined) {
                        localVarQueryParameter['sort_by'] = sort_by;
                    }
                    if (sort_order !== undefined) {
                        localVarQueryParameter['sort_order'] = sort_order;
                    }
                    if (data_source_type !== undefined) {
                        localVarQueryParameter['data_source_type'] = data_source_type;
                    }
                    if (user_id !== undefined) {
                        localVarQueryParameter['user_id'] = user_id;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (is_shared !== undefined) {
                        localVarQueryParameter['is_shared'] = is_shared;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getFilterOptions: function (table, filter_type, domain, tz_name, format, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getFilterOptions', 'table', table);
                    (0, common_1.assertParamExists)('getFilterOptions', 'filter_type', filter_type);
                    (0, common_1.assertParamExists)('getFilterOptions', 'domain', domain);
                    (0, common_1.assertParamExists)('getFilterOptions', 'tz_name', tz_name);
                    localVarPath = "/api_admin_ext/filter_options/{table}/{filter_type}"
                        .replace("{".concat("table", "}"), encodeURIComponent(String(table)))
                        .replace("{".concat("filter_type", "}"), encodeURIComponent(String(filter_type)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    if (tz_name !== undefined) {
                        localVarQueryParameter['tz_name'] = tz_name;
                    }
                    if (format !== undefined) {
                        localVarQueryParameter['format'] = format;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getOauthAttemptStatus: function (sso_config_test_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getOauthAttemptStatus', 'sso_config_test_id', sso_config_test_id);
                    localVarPath = "/api_admin_ext/sso_config/poll_test_status/{sso_config_test_id}"
                        .replace("{".concat("sso_config_test_id", "}"), encodeURIComponent(String(sso_config_test_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSSOConfig: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin_ext/sso_config";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSettings: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin_ext/settings";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getUsers: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, roles, plans, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getUsers', 'domain', domain);
                    (0, common_1.assertParamExists)('getUsers', 'tz_name', tz_name);
                    localVarPath = "/api_admin_ext/users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    if (format !== undefined) {
                        localVarQueryParameter['format'] = format;
                    }
                    if (tz_name !== undefined) {
                        localVarQueryParameter['tz_name'] = tz_name;
                    }
                    if (page_size !== undefined) {
                        localVarQueryParameter['page_size'] = page_size;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (sort_by !== undefined) {
                        localVarQueryParameter['sort_by'] = sort_by;
                    }
                    if (sort_order !== undefined) {
                        localVarQueryParameter['sort_order'] = sort_order;
                    }
                    if (roles !== undefined) {
                        localVarQueryParameter['roles'] = roles;
                    }
                    if (plans !== undefined) {
                        localVarQueryParameter['plans'] = plans;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWebDashboards: function (domain, format, tz_name, page_size, offset, sort_by, sort_order, search, hide_archived, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWebDashboards', 'domain', domain);
                    localVarPath = "/api_admin_ext/web_dashboards";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    if (format !== undefined) {
                        localVarQueryParameter['format'] = format;
                    }
                    if (tz_name !== undefined) {
                        localVarQueryParameter['tz_name'] = tz_name;
                    }
                    if (page_size !== undefined) {
                        localVarQueryParameter['page_size'] = page_size;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (sort_by !== undefined) {
                        localVarQueryParameter['sort_by'] = sort_by;
                    }
                    if (sort_order !== undefined) {
                        localVarQueryParameter['sort_order'] = sort_order;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (hide_archived !== undefined) {
                        localVarQueryParameter['hide_archived'] = hide_archived;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWritebackRuns: function (domain, writeback_id, format, tz_name, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, filters, last_n_days, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin_ext/writeback_runs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    if (writeback_id !== undefined) {
                        localVarQueryParameter['writeback_id'] = writeback_id;
                    }
                    if (format !== undefined) {
                        localVarQueryParameter['format'] = format;
                    }
                    if (tz_name !== undefined) {
                        localVarQueryParameter['tz_name'] = tz_name;
                    }
                    if (page_size !== undefined) {
                        localVarQueryParameter['page_size'] = page_size;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (sort_by !== undefined) {
                        localVarQueryParameter['sort_by'] = sort_by;
                    }
                    if (sort_order !== undefined) {
                        localVarQueryParameter['sort_order'] = sort_order;
                    }
                    if (data_source_type !== undefined) {
                        localVarQueryParameter['data_source_type'] = data_source_type;
                    }
                    if (user_id !== undefined) {
                        localVarQueryParameter['user_id'] = user_id;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (trigger !== undefined) {
                        localVarQueryParameter['trigger'] = trigger;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (last_n_days !== undefined) {
                        localVarQueryParameter['last_n_days'] = last_n_days;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWritebacks: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, data_source_id, filters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWritebacks', 'domain', domain);
                    (0, common_1.assertParamExists)('getWritebacks', 'tz_name', tz_name);
                    localVarPath = "/api_admin_ext/writebacks";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    if (format !== undefined) {
                        localVarQueryParameter['format'] = format;
                    }
                    if (tz_name !== undefined) {
                        localVarQueryParameter['tz_name'] = tz_name;
                    }
                    if (page_size !== undefined) {
                        localVarQueryParameter['page_size'] = page_size;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (sort_by !== undefined) {
                        localVarQueryParameter['sort_by'] = sort_by;
                    }
                    if (sort_order !== undefined) {
                        localVarQueryParameter['sort_order'] = sort_order;
                    }
                    if (data_source_type !== undefined) {
                        localVarQueryParameter['data_source_type'] = data_source_type;
                    }
                    if (user_id !== undefined) {
                        localVarQueryParameter['user_id'] = user_id;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (trigger !== undefined) {
                        localVarQueryParameter['trigger'] = trigger;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (data_source_id !== undefined) {
                        localVarQueryParameter['data_source_id'] = data_source_id;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        modifySSOConfig: function (modify_sso_config_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin_ext/sso_config";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modify_sso_config_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        modifySettings: function (modify_settings_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin_ext/settings";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modify_settings_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateDataSource: function (data_source_id, update_data_source_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateDataSource', 'data_source_id', data_source_id);
                    localVarPath = "/api_admin_ext/data_source/{data_source_id}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_data_source_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
var DefaultApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        configureSSO: function (configure_sso_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.configureSSO(configure_sso_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createOauthAttemptTest: function (create_oauth_attempt_test_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createOauthAttemptTest(create_oauth_attempt_test_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteDataSource: function (data_source_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteDataSource(data_source_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteSSOConfig: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteSSOConfig(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAlerts: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, user_id, status, destination, alert_type, search, filters, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAlerts(domain, tz_name, format, page_size, offset, sort_by, sort_order, user_id, status, destination, alert_type, search, filters, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImportRun: function (data_import_run_id, tz_name, format, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImportRun(data_import_run_id, tz_name, format, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImportRuns: function (domain, data_import_id, format, limit, tz_name, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, filters, last_n_days, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImportRuns(domain, data_import_id, format, limit, tz_name, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, filters, last_n_days, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImports: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, schedule, search, filters, data_source_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImports(domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, schedule, search, filters, data_source_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataSource: function (data_source_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataSource(data_source_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataSources: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, is_shared, search, filters, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataSources(domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, is_shared, search, filters, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getFilterOptions: function (table, filter_type, domain, tz_name, format, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getFilterOptions(table, filter_type, domain, tz_name, format, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getOauthAttemptStatus: function (sso_config_test_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getOauthAttemptStatus(sso_config_test_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSSOConfig: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSSOConfig(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSettings: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSettings(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getUsers: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, roles, plans, search, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getUsers(domain, tz_name, format, page_size, offset, sort_by, sort_order, roles, plans, search, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWebDashboards: function (domain, format, tz_name, page_size, offset, sort_by, sort_order, search, hide_archived, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWebDashboards(domain, format, tz_name, page_size, offset, sort_by, sort_order, search, hide_archived, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWritebackRuns: function (domain, writeback_id, format, tz_name, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, filters, last_n_days, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWritebackRuns(domain, writeback_id, format, tz_name, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, filters, last_n_days, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWritebacks: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, data_source_id, filters, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWritebacks(domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, data_source_id, filters, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        modifySSOConfig: function (modify_sso_config_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.modifySSOConfig(modify_sso_config_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        modifySettings: function (modify_settings_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.modifySettings(modify_settings_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateDataSource: function (data_source_id, update_data_source_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateDataSource(data_source_id, update_data_source_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
var DefaultApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        configureSSO: function (configure_sso_request, options) {
            return localVarFp.configureSSO(configure_sso_request, options).then(function (request) { return request(axios, basePath); });
        },
        createOauthAttemptTest: function (create_oauth_attempt_test_request, options) {
            return localVarFp.createOauthAttemptTest(create_oauth_attempt_test_request, options).then(function (request) { return request(axios, basePath); });
        },
        deleteDataSource: function (data_source_id, options) {
            return localVarFp.deleteDataSource(data_source_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteSSOConfig: function (options) {
            return localVarFp.deleteSSOConfig(options).then(function (request) { return request(axios, basePath); });
        },
        getAlerts: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, user_id, status, destination, alert_type, search, filters, options) {
            return localVarFp.getAlerts(domain, tz_name, format, page_size, offset, sort_by, sort_order, user_id, status, destination, alert_type, search, filters, options).then(function (request) { return request(axios, basePath); });
        },
        getDataImportRun: function (data_import_run_id, tz_name, format, options) {
            return localVarFp.getDataImportRun(data_import_run_id, tz_name, format, options).then(function (request) { return request(axios, basePath); });
        },
        getDataImportRuns: function (domain, data_import_id, format, limit, tz_name, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, filters, last_n_days, options) {
            return localVarFp.getDataImportRuns(domain, data_import_id, format, limit, tz_name, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, filters, last_n_days, options).then(function (request) { return request(axios, basePath); });
        },
        getDataImports: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, schedule, search, filters, data_source_id, options) {
            return localVarFp.getDataImports(domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, schedule, search, filters, data_source_id, options).then(function (request) { return request(axios, basePath); });
        },
        getDataSource: function (data_source_id, options) {
            return localVarFp.getDataSource(data_source_id, options).then(function (request) { return request(axios, basePath); });
        },
        getDataSources: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, is_shared, search, filters, options) {
            return localVarFp.getDataSources(domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, is_shared, search, filters, options).then(function (request) { return request(axios, basePath); });
        },
        getFilterOptions: function (table, filter_type, domain, tz_name, format, options) {
            return localVarFp.getFilterOptions(table, filter_type, domain, tz_name, format, options).then(function (request) { return request(axios, basePath); });
        },
        getOauthAttemptStatus: function (sso_config_test_id, options) {
            return localVarFp.getOauthAttemptStatus(sso_config_test_id, options).then(function (request) { return request(axios, basePath); });
        },
        getSSOConfig: function (options) {
            return localVarFp.getSSOConfig(options).then(function (request) { return request(axios, basePath); });
        },
        getSettings: function (options) {
            return localVarFp.getSettings(options).then(function (request) { return request(axios, basePath); });
        },
        getUsers: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, roles, plans, search, options) {
            return localVarFp.getUsers(domain, tz_name, format, page_size, offset, sort_by, sort_order, roles, plans, search, options).then(function (request) { return request(axios, basePath); });
        },
        getWebDashboards: function (domain, format, tz_name, page_size, offset, sort_by, sort_order, search, hide_archived, options) {
            return localVarFp.getWebDashboards(domain, format, tz_name, page_size, offset, sort_by, sort_order, search, hide_archived, options).then(function (request) { return request(axios, basePath); });
        },
        getWritebackRuns: function (domain, writeback_id, format, tz_name, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, filters, last_n_days, options) {
            return localVarFp.getWritebackRuns(domain, writeback_id, format, tz_name, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, filters, last_n_days, options).then(function (request) { return request(axios, basePath); });
        },
        getWritebacks: function (domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, data_source_id, filters, options) {
            return localVarFp.getWritebacks(domain, tz_name, format, page_size, offset, sort_by, sort_order, data_source_type, user_id, status, trigger, search, data_source_id, filters, options).then(function (request) { return request(axios, basePath); });
        },
        modifySSOConfig: function (modify_sso_config_request, options) {
            return localVarFp.modifySSOConfig(modify_sso_config_request, options).then(function (request) { return request(axios, basePath); });
        },
        modifySettings: function (modify_settings_request, options) {
            return localVarFp.modifySettings(modify_settings_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateDataSource: function (data_source_id, update_data_source_request, options) {
            return localVarFp.updateDataSource(data_source_id, update_data_source_request, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
var DefaultApi = (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultApi.prototype.configureSSO = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).configureSSO(requestParameters.configure_sso_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createOauthAttemptTest = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createOauthAttemptTest(requestParameters.create_oauth_attempt_test_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteDataSource = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteDataSource(requestParameters.data_source_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteSSOConfig = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteSSOConfig(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAlerts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAlerts(requestParameters.domain, requestParameters.tz_name, requestParameters.format, requestParameters.page_size, requestParameters.offset, requestParameters.sort_by, requestParameters.sort_order, requestParameters.user_id, requestParameters.status, requestParameters.destination, requestParameters.alert_type, requestParameters.search, requestParameters.filters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImportRun = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataImportRun(requestParameters.data_import_run_id, requestParameters.tz_name, requestParameters.format, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImportRuns = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataImportRuns(requestParameters.domain, requestParameters.data_import_id, requestParameters.format, requestParameters.limit, requestParameters.tz_name, requestParameters.page_size, requestParameters.offset, requestParameters.sort_by, requestParameters.sort_order, requestParameters.data_source_type, requestParameters.user_id, requestParameters.status, requestParameters.trigger, requestParameters.search, requestParameters.filters, requestParameters.last_n_days, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImports = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataImports(requestParameters.domain, requestParameters.tz_name, requestParameters.format, requestParameters.page_size, requestParameters.offset, requestParameters.sort_by, requestParameters.sort_order, requestParameters.data_source_type, requestParameters.user_id, requestParameters.status, requestParameters.schedule, requestParameters.search, requestParameters.filters, requestParameters.data_source_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataSource = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataSource(requestParameters.data_source_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataSources = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataSources(requestParameters.domain, requestParameters.tz_name, requestParameters.format, requestParameters.page_size, requestParameters.offset, requestParameters.sort_by, requestParameters.sort_order, requestParameters.data_source_type, requestParameters.user_id, requestParameters.status, requestParameters.is_shared, requestParameters.search, requestParameters.filters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getFilterOptions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getFilterOptions(requestParameters.table, requestParameters.filter_type, requestParameters.domain, requestParameters.tz_name, requestParameters.format, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getOauthAttemptStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getOauthAttemptStatus(requestParameters.sso_config_test_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSSOConfig = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSSOConfig(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSettings = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSettings(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getUsers = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getUsers(requestParameters.domain, requestParameters.tz_name, requestParameters.format, requestParameters.page_size, requestParameters.offset, requestParameters.sort_by, requestParameters.sort_order, requestParameters.roles, requestParameters.plans, requestParameters.search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWebDashboards = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWebDashboards(requestParameters.domain, requestParameters.format, requestParameters.tz_name, requestParameters.page_size, requestParameters.offset, requestParameters.sort_by, requestParameters.sort_order, requestParameters.search, requestParameters.hide_archived, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWritebackRuns = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getWritebackRuns(requestParameters.domain, requestParameters.writeback_id, requestParameters.format, requestParameters.tz_name, requestParameters.page_size, requestParameters.offset, requestParameters.sort_by, requestParameters.sort_order, requestParameters.data_source_type, requestParameters.user_id, requestParameters.status, requestParameters.trigger, requestParameters.search, requestParameters.filters, requestParameters.last_n_days, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWritebacks = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWritebacks(requestParameters.domain, requestParameters.tz_name, requestParameters.format, requestParameters.page_size, requestParameters.offset, requestParameters.sort_by, requestParameters.sort_order, requestParameters.data_source_type, requestParameters.user_id, requestParameters.status, requestParameters.trigger, requestParameters.search, requestParameters.data_source_id, requestParameters.filters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.modifySSOConfig = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).modifySSOConfig(requestParameters.modify_sso_config_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.modifySettings = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).modifySettings(requestParameters.modify_settings_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateDataSource = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateDataSource(requestParameters.data_source_id, requestParameters.update_data_source_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
